import React, { useState} from "react";

const PostTab = ({updateInstagramFeedTabData,instagramFeedTabData}) => {
    const [activeSettingTab, setActiveSettingTabsElements] = useState("main");
    const [showPostLikesCount, setIsPostLikesCount] = useState(Number(instagramFeedTabData.post_likes_count));
    const [showPostCommentsCount, setIsPostCommentsCount] = useState(Number(instagramFeedTabData.post_comments_count));
    const [showPostText, setIsPostText] = useState(Number(instagramFeedTabData.post_text));
    const [showPopupUser, setIsPopupUser] = useState(Number(instagramFeedTabData.popup_user));
    const [showPopupInstagramLink, setIsPopupInstagramLink] = useState(Number(instagramFeedTabData.popup_instagram_link));
    const [showPopupLikesCount, setIsPopupLikesCount] = useState(Number(instagramFeedTabData.popup_likes_count));
    const [showPopupShare, setIsPopupShare] = useState(Number(instagramFeedTabData.popup_share));
    const [showPopupText, setIsPopupText] = useState(Number(instagramFeedTabData.popup_text));
    const [showPopupComments, setIsPopupComments] = useState(Number(instagramFeedTabData.popup_comments));
    const [showPopupDate, setIsPopupDate] = useState(Number(instagramFeedTabData.popup_date));
    const [postClickAction, setPostClickAction] = useState(instagramFeedTabData.post_click_action);
    const [showPostClickActionDropdown, setPostClickActionDropdown] = useState(false);
   
    // Handlers Post Likes Count
    const handlePostLikesCountChange = (e) => {
        const checked = e.target.checked;
        setIsPostLikesCount(checked);
        updateInstagramFeedTabData("post_likes_count", checked); 
    };

    // Handlers Post Comments Count
    const handlePostCommentsCountChange = (e) => {
        const checked = e.target.checked;
        setIsPostCommentsCount(checked);
        updateInstagramFeedTabData("post_comments_count", checked); 
    };

    // Handlers Post Text
    const handlePostTextChange = (e) => {
        const checked = e.target.checked;
        setIsPostText(checked);
        updateInstagramFeedTabData("post_text", checked); 
    };

    // Handlers Popup User
    const handlePopupUserChange = (e) => {
        const checked = e.target.checked;
        setIsPopupUser(checked);
        updateInstagramFeedTabData("popup_user", checked); 
    };

    // Handlers Popup Instagram Link
    const handlePopupInstagramLinkChange = (e) => {
        const checked = e.target.checked;
        setIsPopupInstagramLink(checked);
        updateInstagramFeedTabData("popup_instagram_link", checked); 
    };

    // Handlers Popup Likes Count
    const handlePopupLikesCountChange = (e) => {
        const checked = e.target.checked;
        setIsPopupLikesCount(checked);
        updateInstagramFeedTabData("popup_likes_count", checked); 
    };

    // Handlers Popup Share
    const handlePopupShareChange = (e) => {
        const checked = e.target.checked;
        setIsPopupShare(checked);
        updateInstagramFeedTabData("popup_share", checked); 
    };

    // Handlers PopupText
    const handlePopupTextChange = (e) => {
        const checked = e.target.checked;
        setIsPopupText(checked);
        updateInstagramFeedTabData("popup_text", checked); 
    };

    // Handlers Popup Comments
    const handlePopupCommentsChange = (e) => {
        const checked = e.target.checked;
        setIsPopupComments(checked);
        updateInstagramFeedTabData("popup_comments", checked); 
    };

    // Handlers PopupDate
    const handlePopupDateChange = (e) => {
        const checked = e.target.checked;
        setIsPopupDate(checked);
        updateInstagramFeedTabData("popup_date", checked); 
    };

    //Rating Format download on Change
    const togglePostClickActionDropdown = () => {
        setPostClickActionDropdown(!showPostClickActionDropdown);
    };
    //Rating Format on Change
    const handlePostClickActionSelect = (spacing) => {
        setPostClickAction(spacing);
        setPostClickActionDropdown(false);
        updateInstagramFeedTabData("post_click_action", spacing); 
    };
    //Formated value
   const formatLabel = (value) => {
        return value
            .split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    return (
        <div className="side-baar-inner-setting">
            {activeSettingTab === "main" && (
                <>
                    <span>Post</span>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Post Elements</span>
                            <ul>
                                <li>
                                    <div className="form-group">
                                        <input type="checkbox" id="postLikesCount" checked={showPostLikesCount} onChange={handlePostLikesCountChange} /> 
                                        <label for="postLikesCount">Likes Count</label>
                                    </div>
                                </li>
                                <li>
                                    <div className="form-group">
                                        <input type="checkbox" id="postCommentsCount" checked={showPostCommentsCount} onChange={handlePostCommentsCountChange} /> 
                                        <label for="postCommentsCount">Comments Count</label>
                                    </div>
                                </li>
                                <li>
                                    <div className="form-group">
                                        <input type="checkbox" id="postText" checked={showPostText} onChange={handlePostTextChange} /> 
                                        <label for="postText">Text</label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>     
                    <div className="customize-elements-list">
                        <div className="side-baar-box-header mt-0 min-height-140">
                            <div className="box-header-row last-border-none">
                                <span>Post Click Action</span>
                                <div className="salcete-font">
                                    <button><em className="mt-0" onClick={togglePostClickActionDropdown}>{formatLabel(postClickAction)}</em>
                                        {showPostClickActionDropdown && (
                                            <ul className="dropdown-list">
                                                {['Open_in_popup', 'None'].map((spacing) => (
                                                    <li key={spacing} onClick={() => handlePostClickActionSelect(spacing)}>
                                                        {formatLabel(spacing)}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}</button>
                                </div>
                            </div>
                        </div>
                        {postClickAction === "Open_in_popup" && (
                            <ul>
                                <li><button onClick={() => setActiveSettingTabsElements("popup_settings")}>Popup Settings <i className="fa fa-angle-right" aria-hidden="true"></i></button></li>
                            </ul>
                        )}
                    </div>
                </>
            )}

            {activeSettingTab === "popup_settings" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingTabsElements("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Popup Settings</span>
                    </div>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Popup Elements</span>
                            <ul>
                                <li>
                                    <div className="form-group">
                                        <input type="checkbox" id="popupUser" checked={showPopupUser} onChange={handlePopupUserChange} /> 
                                        <label for="popupUser">User</label>
                                    </div>
                                </li>
                                <li>
                                    <div className="form-group">
                                        <input type="checkbox" id="popupInstagramLink" checked={showPopupInstagramLink} onChange={handlePopupInstagramLinkChange} /> 
                                        <label for="popupInstagramLink">Instagram Link</label>
                                    </div>
                                </li>
                                <li>
                                    <div className="form-group">
                                        <input type="checkbox" id="popupLikesCount" checked={showPopupLikesCount} onChange={handlePopupLikesCountChange} /> 
                                        <label for="popupLikesCount">Likes Count</label>
                                    </div>
                                </li>
                                <li>
                                    <div className="form-group">
                                        <input type="checkbox" id="popupShare" checked={showPopupShare} onChange={handlePopupShareChange} /> 
                                        <label for="popupShare">Share</label>
                                    </div>
                                </li>
                                <li>
                                    <div className="form-group">
                                        <input type="checkbox" id="popupText" checked={showPopupText} onChange={handlePopupTextChange} /> 
                                        <label for="popupText">Text</label>
                                    </div>
                                </li>
                                <li>
                                    <div className="form-group">
                                        <input type="checkbox" id="popupComments" checked={showPopupComments} onChange={handlePopupCommentsChange} /> 
                                        <label for="popupComments">Comments</label>
                                    </div>
                                </li>
                                <li>
                                    <div className="form-group">
                                        <input type="checkbox" id="popupDate" checked={showPopupDate} onChange={handlePopupDateChange} /> 
                                        <label for="popupDate">Date</label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default PostTab;